<div class="thumb-icon {{buttonClass}}">
  <div
    *ngIf="isThumbDown"
    (menuOpened)="isMenuOpened.emit(true); menuContent.reset()"
    (menuClosed)="isMenuOpened.emit(false)"
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="appMenu"
  >
  </div>

  <mojo-thumb
    [type]="thumbValue"
    [selected]="selected"
    [matTooltip]="'This is ' + (isThumbUp ? 'good' : 'bad') + ' match'"
    [matTooltipDisabled]="selected"
    [buttonClass]="buttonClass"
    (click)="onThumbClicked($event)"
  >
  </mojo-thumb>

  <mat-menu
    #appMenu="matMenu"
    class="feedback-menu"
    xPosition="before"
    yPosition="below"
  >
    <mojo-feedback-menu-content
      #menuContent
      [feedbackModel]="feedbackModel"
      [title]="'Not a match? Let us know why'"
      [menuType]="TAGS_MENU"
      [thumbIcon]="THUMB_DOWN"
      [reasonTags]="BAD_MATCH_REASONS"
      [resultType]="BAD_MATCH_REASON_TYPE"
      (feedbackSent)="onFeedbackSent($event)"
    >
    </mojo-feedback-menu-content>
  </mat-menu>

  <canvas #confettiCanvas></canvas>
</div>
